import http, { expandURI } from '@/utils/ajax'
import { DEBITNOTE_INIT_LOADING, DEBITNOTE_INIT_SUCCESS, DEBITNOTE_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async debitNoteInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.debitNote
    const expand = {}
    if (apiUrl) {
      commit(DEBITNOTE_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(DEBITNOTE_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(DEBITNOTE_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(DEBITNOTE_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
